import { render, staticRenderFns } from "./cadastro-medico.vue?vue&type=template&id=74bf3146&scoped=true"
import script from "./cadastro-medico.vue?vue&type=script&lang=ts"
export * from "./cadastro-medico.vue?vue&type=script&lang=ts"
import style0 from "./cadastro-medico.vue?vue&type=style&index=0&id=74bf3146&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bf3146",
  null
  
)

export default component.exports